import { render, staticRenderFns } from "./WriteProblem.vue?vue&type=template&id=05e7ab70"
import script from "./WriteProblem.vue?vue&type=script&lang=js"
export * from "./WriteProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports